import { Divider, Grid, Stack, styled, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { ReactNode } from 'react'

export default function ShopInfo() {
    return (
        <Stack
            direction="column"
            spacing={1}
            sx={{width: "100%"}}
        >
            <Typography
                variant="subtitle1"
                color={grey["400"]}
                fontWeight="400"
                sx={{
                    marginTop: "2rem"
                }}
            >
                Shop Information
            </Typography>
            <Divider />

            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <FormInput title="Shop name" placeholder="Name of shop" />
                </Grid>
                <Grid item xs={6}>
                    <FormInput title="Shop Address" placeholder="location" />
                </Grid>
                <Grid item xs={6}>
                    <FormInput title="City" placeholder="eg. Tema" />
                </Grid>
                <Grid item xs={6}>
                    <FormInput title="Country" placeholder="eg. Ghana" />
                </Grid>
            </Grid>
        </Stack>
    )
}

const Input = styled("input")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: ".5px solid rgba(255, 255, 255, 0.1)",
    outline: "none",
    backgroundColor: theme.palette.primary.light,
    padding: "1rem 0.5rem",
    color: grey["500"],
    
}))

const FormInput = ({title, placeholder=""}:{title:ReactNode, placeholder?:string})=>{

    return(
        <Stack
            direction="column"
            spacing={1}
        >
            <Typography
                color={grey['200']}
                fontSize="16px"
                textAlign="left"
            >
                {title}
            </Typography>

            <Input 
                placeholder={placeholder}
            />

        </Stack>
    )

}